// extracted by css-extract-rspack-plugin
export default {"root":"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicMenuButton-module__root-UUivdZ","svg__jeWc1":"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicMenuButton-module__svg__jeWc1-gF9FIC","svgJeWc1":"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicMenuButton-module__svg__jeWc1-gF9FIC","svg___5FElZ":"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicMenuButton-module__svg___5FElZ-nnMVDv","svg5FElZ":"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicMenuButton-module__svg___5FElZ-nnMVDv"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicMenuButton-module__root-UUivdZ\",\"svg__jeWc1\":\"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicMenuButton-module__svg__jeWc1-gF9FIC\",\"svgJeWc1\":\"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicMenuButton-module__svg__jeWc1-gF9FIC\",\"svg___5FElZ\":\"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicMenuButton-module__svg___5FElZ-nnMVDv\",\"svg5FElZ\":\"src-wab-client-plasmic-plasmic_kit_design_system-PlasmicMenuButton-module__svg___5FElZ-nnMVDv\"}";
        // 1793541993550
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  